import Helmet from "react-helmet";
import { IoChevronForwardOutline } from "react-icons/io5";
import { Link } from "react-router";
import styled from "styled-components";

import BimClassList from "./BimClassList";
import { TAXONOMY_BASE } from "../../../../../constants";
import * as UI from "../../../../../modules/ui-kit";

const StyledBimClassInventory = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    overflow: hidden auto;
    width: 100%;

    header {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .nav-breadcrumbs {
            align-items: center;
            display: flex;
            gap: 6px;
            font-size: 0.8rem;

            a {
                color: #6b778c;
                text-decoration: none;
                font-weight: 500;

                &:hover {
                    color: #0052cc;
                }
            }

            svg {
                color: #a5adba;
                font-size: 0.75rem;
            }

            .current {
                color: #172b4d;
                font-weight: 600;
            }
        }

        h2 {
            color: #172b4d;
            font-size: 1.25rem;
            font-weight: 700;
            letter-spacing: -.02em;
            margin: 0;
        }
    }
`;

export default function BimClassInventory(props) {
    const { guard } = props;

    return (
        <StyledBimClassInventory>
            <Helmet>
                <title>BimClasses - taxonomy</title>
            </Helmet>
            <header>
                <div className="nav-breadcrumbs">
                    <Link to={ TAXONOMY_BASE }>Home</Link>
                    <IoChevronForwardOutline />
                    <span className="current">BimClasses</span>
                </div>
                <h2>BimClasses</h2>
                <UI.Button
                    $size="small"
                    as={ Link }
                    to="new"
                >
                    New BimClass
                </UI.Button>
            </header>
            <BimClassList guard={ guard } />
        </StyledBimClassInventory>
    );
}
